module.exports = __webpack_public_path__ + "static/media/404.267d8e4c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/app/views/errors/404.gif
// module id = 1322
// module chunks = 389